import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
});

const toQuery = (filters, extra = {}) => {
  const params = new URLSearchParams();
  if (filters.startDate) params.set("startDate", filters.startDate);
  if (filters.endDate) params.set("endDate", filters.endDate);
  if (filters.shippingState) params.set("shippingState", filters.shippingState);
  if (filters.governorate) params.set("governorate", filters.governorate);
  if (filters.city) params.set("city", filters.city);
  if (filters.carrier) params.set("carrier", filters.carrier);
  if (filters.paymentMethod) params.set("paymentMethod", filters.paymentMethod);
  if (filters.search) params.set("search", filters.search);
  Object.entries(extra).forEach(([key, value]) => {
    if (value != null && value !== "") params.set(key, String(value));
  });
  return params.toString();
};

const readError = async (response, fallback) => {
  const data = await response.json().catch(() => ({}));
  throw new Error(data?.message || data?.error || fallback);
};

export const fetchFincartAnalyticsFilters = async () => {
  const response = await fetch(`${API_BASE_URL}/FincartAnalytics/filters`, {
    headers: authHeaders(),
  });
  if (!response.ok) await readError(response, "فشل تحميل فلاتر شحن Fincart");
  return response.json();
};

export const fetchFincartAnalyticsSummary = async (filters) => {
  const response = await fetch(`${API_BASE_URL}/FincartAnalytics/summary?${toQuery(filters)}`, {
    headers: authHeaders(),
  });
  if (!response.ok) await readError(response, "فشل تحميل تحليلات Fincart");
  return response.json();
};

export const fetchFincartAnalyticsOrders = async (filters, page, pageSize) => {
  const response = await fetch(
    `${API_BASE_URL}/FincartAnalytics/orders?${toQuery(filters, { page, pageSize })}`,
    { headers: authHeaders() }
  );
  if (!response.ok) await readError(response, "فشل تحميل طلبات Fincart");
  return response.json();
};

export const downloadDeliveredCustomersCsv = async (filters) => {
  const response = await fetch(
    `${API_BASE_URL}/FincartAnalytics/delivered-customers.csv?${toQuery({
      ...filters,
      shippingState: undefined,
    })}`,
    { headers: authHeaders() }
  );
  if (!response.ok) await readError(response, "فشل تصدير عملاء التسليم");
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "fincart-delivered-customers.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
